import { Col, Text } from 'components';

const Stats = ({ data }) => {
  if (!data) return null;

  return (
    <Col marg="24px 0 0">
      <Text h2>t('common.stats')</Text>
    </Col>
  );
};

export default Stats;
